import React from 'react';
import { string, func } from 'prop-types';
import {
  Button,
  DrawerBody,
  DrawerFooter,
  Typography,
  Alert,
} from '@one-thd/sui-atomic-components';

export const SuccessDrawer = ({
  quoteName,
  onClose
}) => {

  return (
    <>
      <DrawerBody>
        <Alert status="success">
          <Typography>Success!</Typography>
          Your item has been added to your quote:{' '}
          <u>{quoteName}</u>
        </Alert>
      </DrawerBody>
      <DrawerFooter>
        <Button
          fullWidth
          variant="primary"
          onClick={onClose}
        >
          OK
        </Button>
      </DrawerFooter>
    </>
  );
};

SuccessDrawer.propTypes = {
  quoteName: string,
  onClose: func.isRequired
};

SuccessDrawer.defaultProps = {
  quoteName: ''
};

SuccessDrawer.displayName = 'AddToQuoteSuccessDrawer';